export class Addresses {
    static toText(address: any) : string {
        if(address) {
            return address.street + ', ' + address.city + (address.county ? ', ' + address.county : '') + ', ' + address.state;
        } else {
            return null;
        }
    }
}